const KEYS = ['pricedByOrder', 'noPriceRule', 'noPrice', 'noEngineVolume'];

// Ð¡ÑÑÑÑÐ¸ÐºÐ¸ ÑÐµÐ½ Ð¸Ð· Ð¾ÑÐ²ÐµÑÐ° Ð±ÑÐºÐ° (StockImportResult). ÐÐ°ÑÑÐ¾ÑÐºÐ° Ð¸ÑÐ¾Ð³Ð¾Ð² ÑÐ¸ÑÐ°ÐµÑ Ð¸Ñ Ð¸Ð· result â
// Ð±ÐµÐ· ÑÐ²Ð½Ð¾Ð³Ð¾ Ð¿ÐµÑÐµÐ½Ð¾ÑÐ° Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð¾Ð½Ð° Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð° Ð±Ñ 0. carWarnings â ÑÐµ Ð¶Ðµ
// Ð·Ð°Ð¼ÐµÑÐ°Ð½Ð¸Ñ Ð¿Ð¾Ð¸Ð¼ÑÐ½Ð½Ð¾ (Ð¿Ð¾ ÐºÐ°ÐºÐ¸Ð¼ Ð¼Ð°ÑÐ¸Ð½Ð°Ð¼)
export const importCounters = (data) => ({
  ...Object.fromEntries(KEYS.map((k) => [k, data?.[k] ?? 0])),
  carWarnings: data?.carWarnings ?? [],
});

// Ð ÑÑÐ½Ð°Ñ Ð¿ÑÐ°Ð²ÐºÐ° ÑÑÑÐ¾Ðº Ð´Ð¾ÑÑÐ»Ð°ÐµÑ ÐµÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ â Ð¸Ñ ÑÑÑÑÑÐ¸ÐºÐ¸ Ð¿ÑÐ¸Ð±Ð°Ð²Ð»ÑÑÑÑÑ Ðº ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¼
export const addImportCounters = (prev, data) => ({
  ...Object.fromEntries(KEYS.map((k) => [k, (prev?.[k] ?? 0) + (data?.[k] ?? 0)])),
  carWarnings: [...(prev?.carWarnings ?? []), ...(data?.carWarnings ?? [])],
});
